var render = function render(){
  var _vm$currentJoinReques, _vm$currentJoinReques2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    ref: "my-modal",
    attrs: {
      "size": "lg",
      "title": _vm.title,
      "ok-title": "Accept",
      "cancel-title": "Decline",
      "ok-variant": "success",
      "cancel-variant": "danger",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "busy": _vm.busy
    },
    on: {
      "ok": _vm.handleAccept,
      "cancel": _vm.handleDecline
    }
  }, [_c('p', {
    staticClass: "my-2"
  }, [_vm._v("You have Join Requests from the following users:")]), _vm._l(_vm.orgs, function (item) {
    return _c('li', {
      key: item,
      staticClass: "font-weight-bold px-2 py-0"
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), _c('p', {
    staticClass: "my-2"
  }, [_vm._v(" Do you want to accept below user to be part of your Organization? "), _c('br'), _c('b', [_vm._v(_vm._s((_vm$currentJoinReques = _vm.currentJoinRequest) === null || _vm$currentJoinReques === void 0 ? void 0 : _vm$currentJoinReques.requesterName) + " (" + _vm._s((_vm$currentJoinReques2 = _vm.currentJoinRequest) === null || _vm$currentJoinReques2 === void 0 ? void 0 : _vm$currentJoinReques2.requesterEmail) + ")")])])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }